import {
  IsArray,
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  IsIn,
} from 'class-validator';

import { IsSnils } from '@vk-hr-tek/core/validation';

export class CreateAttorneyDto {
  @IsArray({ groups: ['submit'] })
  @IsUUID(undefined, { each: true, groups: ['submit'] })
  @IsNotEmpty({ groups: ['submit'] })
  user_ids: string[];

  @IsUUID(undefined, { groups: ['submit'] })
  @IsNotEmpty({ groups: ['submit'] })
  company_id: string;

  @IsSnils({ message: 'Неверный СНИЛС', groups: ['form', 'submit'] })
  @IsString({
    message: 'Поле обязательно для заполнения',
    groups: ['form', 'submit'],
  })
  @IsNotEmpty({
    message: 'Поле обязательно для заполнения',
    groups: ['form', 'submit'],
  })
  principal_snils: string;

  @IsOptional({ groups: ['form', 'submit'] })
  @IsString({ groups: ['form', 'submit'] })
  @IsIn(['cooperative', 'individual'])
  principal_powers_cooperation?: 'cooperative' | 'individual';

  @IsString({ groups: ['form', 'submit'] })
  @IsNotEmpty({ groups: ['form', 'submit'] })
  @IsIn(['cooperative', 'individual'])
  confidant_powers_cooperation: 'cooperative' | 'individual';

  @IsString({ groups: ['form'] })
  @IsNotEmpty({ groups: ['form'] })
  powersType: string;

  @IsOptional({ groups: ['form', 'submit'] })
  @IsString({
    groups: ['form', 'submit'],
  })
  powers?: string;

  @IsDateString(undefined, {
    message: 'Некорректная дата',
    groups: ['form', 'submit'],
  })
  @IsNotEmpty({
    message: 'Поле обязательно для заполнения',
    groups: ['form', 'submit'],
  })
  valid_to: string;
}
